// ----------------------------------------------------------------------

const shape = {
  borderRadius: 6,
  borderRadiusSm: 8,
  borderRadiusMd: 12,
};

export default shape;
